const getterEditorModePPT = (state) => {
  return state.isEnableAddinPowerpoint && state.isPPTEditMode
}

// AHA-43274: "this add-in frame is NOT the frame the slideshow is currently on."
//
// A PowerPoint deck boots every add-in frame at once, each an independent presenter instance with
// its own store, so during a slideshow every background frame still holds a fully live slide. That
// slide keeps doing three things nobody asked it to: it runs the quiz countdown (which both starts
// the question and, at times-up, ends it — writing quizStatus to the server), it plays audio, and it
// re-asserts itself as the active slide on visibilitychange. This getter is the single term all
// three switch on.
//
// An earlier cut used the same condition to unmount the Middle subtree outright. That worked but
// disturbed the layout, so the frame now renders normally and only its side effects are suppressed.
//
// All four terms are load-bearing:
//   - isEnableAddinPowerpoint — no other host runs several frames of the same presentation at once,
//     so nowhere else can a frame be "not the one presenting".
//   - the flag — off restores the original behaviour exactly, everywhere this is consulted.
//   - addinPPTActiveView === 'read' — pptSlideLostFocus is a LATCH consumed by a re-assert, so a
//     frame that stands down and never regains the show carries it true back out of the slideshow.
//     Without this term that frame would sit in the EDITOR with its timers and audio disabled and
//     nothing left running to clear the flag.
//   - pptSlideLostFocus — the tag poll's verdict that the slide on screen is not this frame's.
//
// Root getter rather than a per-component computed because the consumers are spread across a Vuex
// module (audio) and three components that share no ancestor.
const isPptFrameStoodDown = (state, getters) => {
  return Boolean(
    state.isEnableAddinPowerpoint
    && getters['featureToggles/canUsePptAutoStopQuiz']
    && state.addinPPTActiveView === 'read'
    && state.pptSlideLostFocus,
  )
}

export default {
  getterEditorModePPT,
  isPptFrameStoodDown,
}
